import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { ObjectClassSettingsType } from '@atlassian/jira-assets-data-manager-common/src/common/types.tsx';

const SETTING_TYPES: readonly ObjectClassSettingsType[] = [
	'mapping-matrix',
	'default-attribute-mapping',
	'cleansing-statistics',
	'data-dictionaries',
] as const;

// TODO: Import and add entrypoints for each setting type when they are created
// const SETTINGS = {
// 	'mapping-matrix': mappingMatrixEntryPoint,
// 	'default-attribute-mapping': defaultAttributeMappingEntryPoint,
// 	'cleansing-statistics': cleansingStatisticsEntryPoint,
// 	'data-dictionaries': dataDictionariesEntryPoint,
// } as const;

const isValidSettingType = (settingType: unknown): settingType is ObjectClassSettingsType => {
	if (typeof settingType !== 'string') {
		return false;
	}
	return SETTING_TYPES.some((validType) => validType === settingType);
};

export const assetsDataManagerObjectClassSettingsEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-assets-data-manager-object-class-settings", jiraSpaEntry: "async-assets-data-manager-object-class-settings" */ './src'
			),
	),
	getPreloadProps: ({
		context: {
			match: { params },
		},
	}: EntryPointRouteParams) => {
		const validSettingType = isValidSettingType(params?.settingType)
			? params.settingType
			: undefined;
		// TODO: When entrypoints are created for each setting type, uncomment SETTINGS object above
		// and update this to return:
		// return {
		// 	entryPoints: validSettingType
		// 		? {
		// 				[validSettingType]: {
		// 					entryPoint: SETTINGS[validSettingType],
		// 					entryPointParams: {},
		// 				},
		// 			}
		// 		: {},
		// 	extraProps: {},
		// };
		return {
			entryPoints: {},
			extraProps: {
				settingType: validSettingType,
			},
		};
	},
});
